import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GenericDocumentRoutingModule } from "./generic-document-routing.module";
import { RouterModule } from "@angular/router";
import { AngularMaterialModule } from "@cradua/material";
import { HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { SharedModule } from "@cradua/shared";
import { NgxDocViewerModule } from "./components/document-viewer/document-viewer.module";
import { AngularImageViewerModule } from "angular-x-image-viewer";
import { SpinnersModule } from "@cradua/spinners";
import { StoreModule } from "@ngrx/store";
import * as DocumentReducer from "../lib/document-states";
import { UploadDocumentComponent } from "./components/upload-document/upload-document.component";
import { EffectsModule } from "@ngrx/effects";
import { DocumentEffects } from "../lib/document-states/document.effects";
import { DocumentFacade } from "../lib/document-states/document.facade";
import { DocumentDialogComponent } from "./components/upload-document/document-dialog/document-dialog.component";
import { DocumentContainerComponent } from './containers/document-container/document-container.component';
import { DocumentoperationsComponent } from './components/documentoperations/documentoperations.component';
@NgModule({
  imports: [
    CommonModule,
    GenericDocumentRoutingModule,
    RouterModule,
    AngularMaterialModule,
    HttpClientModule,
    SpinnersModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDocViewerModule,
    AngularImageViewerModule,
    StoreModule.forFeature(
      DocumentReducer.DocumentStoreReducer.DOCUMENT_FEATURE_KEY,
      DocumentReducer.DocumentStoreReducer.documentReducer,
    ),
    EffectsModule.forFeature([DocumentEffects]),
  ],
  declarations: [
    UploadDocumentComponent,
    DocumentDialogComponent,
    DocumentContainerComponent,
    DocumentoperationsComponent],
  providers: [DocumentFacade],
  exports: [
    UploadDocumentComponent,
     DocumentDialogComponent,
     DocumentoperationsComponent],
  // entryComponents: [DocumentDialogComponent],
})
export class GenericDocumentModule {}
